import { IconProps } from "../../utils/global-types/global-types";

const AddUserIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M7.72 2.333a2.996 2.996 0 1 0 0 5.993 2.996 2.996 0 0 0 0-5.993M8.019 9.79c.168-.245.006-.618-.29-.619H6.93a4.46 4.46 0 0 0-4.46 4.46 1.82 1.82 0 0 0 1.82 1.819h3.481c.3 0 .462-.383.288-.627a4.37 4.37 0 0 1-.813-2.546c0-.924.285-1.78.772-2.488"
    ></path>
    <g clipPath="url(#clip0_10604_138662)">
      <path
        fill="currentColor"
        d="M11.637 8.776c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5"
      ></path>
      <path
        fill="#fff"
        d="M11.928 13.807a.291.291 0 1 1-.583 0v-1.24h-1.24a.29.29 0 1 1 0-.582h1.24v-1.24a.291.291 0 1 1 .583 0v1.24h1.24a.291.291 0 1 1 0 .583h-1.24z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_10604_138662">
        <path fill="#fff" d="M8.137 8.776h7v7h-7z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default AddUserIcon;
